import React, { useState, useEffect } from 'react';
//import axios from 'axios';
import updateFormCSS from '../updateProduct/updateForm.module.css';
import Loader from '../../loader';
import { API_BASE_URL } from '../../../constants';
import { axiosAuthFetch, axiosImageAuthFetch } from '../../../helpers/apiActions/authFetch';

export function UpdateVerkstedForm({ verksted }) {

    console.log('VERKSTED',verksted);
    const {username, address, telephone, email, contact_person, kjede} = verksted;
    const id = verksted.id;

    const [userName, setUserName] = useState(username);
    const [userEmail, setUserEmail] = useState(email);
    const [region, setRegion] = useState(address ? address.region : '');
    const [country, setCountry] = useState(address ? address.country : '');
    const [city, setCity] = useState(address ? address.city : '');
    const [street, setStreet] = useState(address ? address.street : '');
    const [zip, setZip] = useState(address ? address.zip : '');
    const [contactName, setContactName] = useState(contact_person ? contact_person.name : '');
    const [contactEmail, setContactEmail] = useState(contact_person ? contact_person.email : '');
    const [contactPhone, setContactPhone] = useState(contact_person ? contact_person.telephone : '');
    const [isLoading, setIsLoading] = useState(false);
    const [kjeder, setKjeder] = useState([]);
    const [selectedKjedeId, setSelectedKjedeId] = useState(kjede ? kjede.id : '');
    const [verkstedPhone, setVerkstedPhone] = useState(telephone? telephone : '');

    useEffect(() => {
        async function fetchSuppliers() {
            try {
                const response =  await axiosAuthFetch('https://renowned-oasis-58a898da10.strapiapp.com/api/kjedes');
                console.log(response.data);
                setKjeder(response.data);
                console.log(kjeder);
            } catch(error) {
                console.error(error);
            }
        }
        fetchSuppliers();
        // eslint-disable-next-line
    }, []);

    const handleUserNameChange = (event) => {
        setUserName(event.target.value);
    };
    const handleUserEmailChange = (event) => {
        setUserEmail(event.target.value);
    };
    const handleRegionChange = (event) => {
        setRegion(event.target.value);
    };
    const handleCountryChange = (event) => {
        setCountry(event.target.value);
    };
    const handleStreetChange = (event) => {
        setStreet(event.target.value);
    };
    const handleZipChange = (event) => {
        setZip(event.target.value);
    };
    const handleCityChange = (event) => {
        setCity(event.target.value);
    };
    const handleContactNameChange = (event) => {
        setContactName(event.target.value);
    };
    const handleContactEmailChange = (event) => {
        setContactEmail(event.target.value);
    };
    const handleContactPhoneChange = (event) => {
        setContactPhone(event.target.value);
    };

    const handleTelephoneNumberChange = (event) => {
        setVerkstedPhone(event.target.value);
    }

    const handleKjedeChange = (event) => {
        setSelectedKjedeId(event.target.value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);


        try {
            const address = {
                address: {
               "street" : street,
               "zip" : zip,
               "country" : country,
               "region" : region,
               "city" : city
               }
           }  

           const contactInfo = {
               contact_person: {
                   "name" : contactName,
                   "email" : contactEmail,
                   "telephone" : contactPhone
               }
           }

           const kjedeInfo = {
            kjede: selectedKjedeId
            };

            const addressResponse = await axiosAuthFetch(`${API_BASE_URL}/users/${id}`, address, 'put')
            const contactResponse = await axiosAuthFetch(`${API_BASE_URL}/users/${id}`, contactInfo, 'put')
            const kjedeResponse = await axiosAuthFetch(`${API_BASE_URL}/users/${id}`, kjedeInfo, 'put');
            console.log(addressResponse, contactResponse, kjedeResponse);


            const verkstedData = new FormData();
            verkstedData.append('username', userName);
            verkstedData.append('email', userEmail);
            verkstedData.append('telephone', verkstedPhone);

            const updateVerksted = await axiosImageAuthFetch(`https://renowned-oasis-58a898da10.strapiapp.com/api/users/${id}`, verkstedData, 'put');
            console.log(updateVerksted.response);
            //response handling
                setIsLoading(false);
                alert('Verkstedsinformasjon oppdatert!')
                window.location.reload();

        } catch (error) {
            console.error('Feil ved opplasting av bilde eller innsending av skjemadata:', error);
        }
    };

    return (
        <div>
            {isLoading && <Loader />}
            <div className={updateFormCSS.p}>
                <h2>Oppdater verkstedsinfo</h2>
            </div>
            <form className={updateFormCSS.form} onSubmit={handleSubmit}>
                <div>Verkstedinfo</div>
                <input className={updateFormCSS.input} type="text" value={userName} onChange={handleUserNameChange} placeholder="Navn" required/>
                <input className={updateFormCSS.input} type="text" value={userEmail} onChange={handleUserEmailChange} placeholder="E-post" required/>
                <input className={updateFormCSS.input} type="text" value={verkstedPhone} onChange={handleTelephoneNumberChange} placeholder="Telefonnummer" required/>
                <div>Addresse</div>
                <input className={updateFormCSS.input} type="text" value={city} onChange={handleCityChange} placeholder="By" />
                <input className={updateFormCSS.input} type="text" value={street} onChange={handleStreetChange} placeholder="Adresse" />
                <input className={updateFormCSS.input} type="text" value={zip} onChange={handleZipChange} placeholder="Postkode" />
                <input className={updateFormCSS.input} type="text" value={region} onChange={handleRegionChange} placeholder="Region" />
                <input className={updateFormCSS.input} type="text" value={country} onChange={handleCountryChange} placeholder="Land" />
                <div>Kontakperson</div>
                <input className={updateFormCSS.input} type="text" value={contactName} onChange={handleContactNameChange} placeholder="Navn" />
                <input className={updateFormCSS.input} type="text" value={contactEmail} onChange={handleContactEmailChange} placeholder="E-mail" />
                <input className={updateFormCSS.input} type="text" value={contactPhone} onChange={handleContactPhoneChange} placeholder="Telefon" />
                <div className={updateFormCSS.subHeading}>Kjede</div>
                <select className={updateFormCSS.select} value={selectedKjedeId} onChange={handleKjedeChange}>
                    <option value="">Velg kjede</option>
                    {kjeder.map(kjede => (
                        <option key={kjede.id} value={kjede.id}>{kjede.attributes.name}</option>
                    ))}
                </select>
                {/* <h3 className={addProductCSS.h3}>Bilde</h3>
                <input className={addProductCSS.fileInput}  type="file" onChange={handleFileChange} />
                <h3 className={addProductCSS.h3}>Katalogbilde</h3>
                <input className={addProductCSS.fileInput}  type="file" onChange={handleFile2Change} /> */}
                <button className={updateFormCSS.button} type="submit">Oppdater verkstedsinfo</button>
            </form>
        </div>
    );
}

export default UpdateVerkstedForm;